import { ShieldCheck } from 'lucide-react';

const SECTIONS = [
  {
    titleKey: 'privacySec1Title',
    bodyKey:  'privacySec1Body',
  },
  {
    titleKey: 'privacySec2Title',
    bodyKey:  'privacySec2Body',
  },
  {
    titleKey: 'privacySec3Title',
    bodyKey:  'privacySec3Body',
  },
  {
    titleKey: 'privacySec4Title',
    bodyKey:  'privacySec4Body',
  },
  {
    titleKey: 'privacySec5Title',
    bodyKey:  'privacySec5Body',
  },
  {
    titleKey: 'privacySec6Title',
    bodyKey:  'privacySec6Body',
  },
];

function PrivacyPolicyPage({ t }) {
  return (
    <div className="mx-auto max-w-4xl space-y-6">
      {/* Hero */}
      <section className="overflow-hidden rounded-3xl border border-slate-200 bg-gradient-to-br from-[#1A1A1A] via-brand-600 to-green-500 p-8 text-white shadow-xl shadow-brand/20 dark:border-slate-800">
        <div className="mb-3 inline-flex items-center gap-2 rounded-full bg-white/15 px-3 py-1 text-sm font-semibold">
          <ShieldCheck size={16} />
          {t('navPrivacyPolicy')}
        </div>
        <h1 className="text-3xl font-bold md:text-4xl">{t('privacyTitle')}</h1>
        <p className="mt-3 text-sm leading-6 text-brand-50">
          {t('privacyLastUpdated')}
        </p>
      </section>

      {/* Intro */}
      <div className="rounded-3xl border border-slate-200 bg-white p-8 shadow-sm dark:border-slate-800 dark:bg-slate-900">
        <p className="leading-7 text-slate-600 dark:text-slate-300">
          {t('privacyIntro')}
        </p>
      </div>

      {/* Sections */}
      <div className="space-y-4">
        {SECTIONS.map((sec, i) => (
          <section
            key={sec.titleKey}
            className="rounded-3xl border border-slate-200 bg-white p-6 shadow-sm dark:border-slate-800 dark:bg-slate-900"
          >
            <div className="flex items-start gap-4">
              <span className="inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-brand-100 text-sm font-bold text-brand-700 dark:bg-brand-900/40 dark:text-brand-300">
                {i + 1}
              </span>
              <div>
                <h2 className="text-lg font-bold text-slate-900 dark:text-white">
                  {t(sec.titleKey)}
                </h2>
                <p className="mt-2 leading-7 text-slate-600 dark:text-slate-300">
                  {t(sec.bodyKey)}
                </p>
              </div>
            </div>
          </section>
        ))}
      </div>

      {/* Footer */}
      <div className="rounded-3xl border border-slate-200 bg-slate-50 p-6 text-center text-sm text-slate-500 dark:border-slate-800 dark:bg-slate-900/50 dark:text-slate-400">
        {t('privacyContact')}
      </div>
    </div>
  );
}

export default PrivacyPolicyPage;
